import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import styles from "./article-hero.module.css"
import classNames from "classnames/bind"

export default function ArticleHero({ block }) {
  const cx = classNames.bind(styles)

  if (block.innerBlocks === undefined) {
    return null
  }

  let width = block.attrs.hasImage ? "full" : "column"
  width = block.attrs.hasVideo ? "bleed" : width

  const classes = {
    wrapper: true,
    "has-image": block.attrs.hasImage,
    "has-video": block.attrs.hasVideo
  }

  const settings = {
    "core/image": { priority: true }
  }

  return (
    <Block block={block} width={width} gap="small" className={cx(classes)}>
      <Blocks blocks={block.innerBlocks} settings={settings} />
    </Block>
  )
}
